import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { exchangeSession } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) {
      navigate("/");
      return;
    }
    exchangeSession(sessionId)
      .then(() => {
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard");
      })
      .catch(() => {
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/");
      });
  }, [exchangeSession, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground text-sm font-mono uppercase tracking-wider">
      Connexion en cours…
    </div>
  );
}
